<template>
  <div class="viewer">
    <b-card class="border-none py-0 mb-0 no-margin px-1">
      <b-card-header>
        <b-row align-v="top" no-gutters>
          <b-col cols="8">
            <b-button
              v-print="'#paper'"
              squared
              size="sm"
              class="mr-4 inline"
              title="Print"
            >
              <i class="fa fa-print pr-3"></i>Print
            </b-button>
            <!--  <div class="inline-block">
              <i class="fa fa-envelope fa-2x mr-1 text-primary"></i>             
            </div> -->
          </b-col>
          <b-col class="text-right">
            <b-button-group>
              <b-button squared size="sm" variant="secondary" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>Back
              </b-button></b-button-group
            >
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <div id="paper" class="mb-3 p-4 bg-white text-secondary">
          <div class="border-black">
            <b-row>
              <b-col cols="1">
                <img
                  src="/img/brand/logo.gif"
                  title="Travel Places"
                  alt="Travel Places"
                  height="50px"
                />
              </b-col>
              <b-col class="mt-2"
                ><strong>{{ item.name }}</strong></b-col
              >
            </b-row>
            <b-row class="mb-2">
              <b-col cols="1"></b-col>
              <b-col>
                <div v-if="item.data">
                  <div v-html="$helpers.breaklines(item.data)"></div>
                </div>
                <div v-else>There are no further details to show</div>
                <!--    <div v-if="item.link" slot="footer">
                  <i
                    v-if="item.link"
                    :class="
                      item.link.startsWith('http')
                        ? 'fa fa-external-link pr-2'
                        : 'fa fa-link pr-2'
                    "
                  ></i>
                  <b-link
                    v-if="item.link"
                    :to="!item.link.startsWith('http') ? item.link : null"
                    :href="item.link.startsWith('http') ? item.link : null"
                    :target="item.link.startsWith('http') ? '_blank' : null"
                    >{{ item.link }}</b-link
                  >
                </div> -->
              </b-col>
            </b-row>
          </div>
        </div>
      </b-card-body>

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button squared size="sm" variant="secondary" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";


export default {
  name: "TaskViewer",

  data() {
    return {
      busy: false,
      message: "",
      item: { items: [] },
      options: {
        title: "Task Viewer",
        icon: "fa fa-tasks",
      },
    };
  },
  computed: {
    color() {
      if (this.item.level || this.item.level == 0) {
        switch (this.item.level) {
          case 0:
            return "info";
          case 1:
            return "danger";
          case 2:
            return "warning";
        }
      }
    },
  },
  methods: {
    async load() {
      let variables = {
        id: this.idselected,
        dateformat: this.dateformat,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query tasks($id: String) {
              tasks(id: $id) {
                id
                name
                category
                level
                data
                duration
                created_at
              }
            }
          `,
          variables,
        });

        this.item = response.data.tasks[0];
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
  },
};
</script>

<style>
</style>
